import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";
import { INVERITE_FETCH_API_URL } from "../ApiUrls";

export default class FetchInveriteRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(INVERITE_FETCH_API_URL);

  getBody = () => this.body;
}
